import { BphVehicleModel } from './BphTypes';

export class VehicleMapDisplayPool {
    private vehicles: Record<string, BphVehicleModel> = {};
    private highlighted?: string;

    constructor(_helper: any) {
        // helper preserved for compatibility
    }

    public set(vehicles: Record<string, BphVehicleModel>) {
        this.vehicles = { ...vehicles };
    }

    public has(id: string): boolean { return !!this.vehicles[id]; }

    public get(id: string): BphVehicleModel {
        return this.vehicles[id];
    }

    public add(vehicle: BphVehicleModel) {
        this.vehicles[vehicle.id] = vehicle;
    }

    public empty() {
        this.vehicles = {};
        this.highlighted = undefined;
    }

    public setVehicles(positions: any[] | null) {
        this.empty();
        if (positions) {
            for (const p of positions) {
                this.add(new BphVehicleModel(p));
            }
        }
    }

    public highlight(id?: string) {
        this.highlighted = id;
    }

    public get highlightedId(): string | undefined {
        return this.highlighted;
    }
}
